import axios from "axios"

export default function(config) {
    const { slug, extraFields = {}, extraPriceFields = [], extraWatchFields = [] } = config;

    return {
        life_insurance: 'Nej',
        veterinary_care: '50000',
        veterinary_care_deductible: '1500_25',
        insurance_amount: '',
        insurance_start_date: '',
        owns_horse: 'Nej',
        chip: '',
        ...extraFields,

        // Meta
        veterinary_care_insurance_name: '',
        veterinary_care_insurance_documents: [],
        life_insurance_name: '',
        life_insurance_documents: [],
        life_insurance_active: false,

        // State
        price: '...',
        loading: false,
        errors: {},

        show_price: false,

        insurance_amount_max: 0,

        veterinaryCareDeductiblePrettyMap: {
            '1500_25': '1 500 kr + 25%',
            '3500_25': '3 500 kr + 25%',
            '0_50': '50%',
        },

        veterinary_care_deductible_pretty: '1 500 kr + 25%',

        updatePriceTimeout: null,

        init() {
            this.getData().then(() => {
                this.updateDeductiblePretty();
                this.setupWatchers();
                this.updatePrice();
                this.getMeta();
            });
        },

        updateDeductiblePretty() {
            this.veterinary_care_deductible_pretty = this.veterinaryCareDeductiblePrettyMap[this.veterinary_care_deductible] ?? this.veterinary_care_deductible;
        },

        getData() {
            return new Promise((resolve, reject) => {
                axios.post('/step/' + slug + '/data').then(response => {
                    let data = response.data;

                    for (let key in data) {
                        this[key] = data[key];
                    }

                    resolve();
                }).catch(error => {
                    console.error(error);
                    reject();
                });
            });
        },

        getMeta() {
            axios.post('/step/' + slug + '/meta', {
                life_insurance: this.life_insurance,
                life_insurance_active: this.life_insurance_active,
            }).then(response => {
                this.veterinary_care_insurance_name = response.data.veterinary_care_insurance_name;
                this.life_insurance_name = response.data.life_insurance_name;
                this.veterinary_care_insurance_documents = response.data.veterinary_care_insurance_documents;
                this.life_insurance_documents = response.data.life_insurance_documents;
            }).catch(error => {
                console.error(error);
            });
        },

        updatePrice() {
            clearTimeout(this.updatePriceTimeout);
            this.updatePriceTimeout = setTimeout(() => {
                this.price = '...';
                this.errors = {};

                let data = {
                    veterinary_care: this.veterinary_care,
                    veterinary_care_deductible: this.veterinary_care_deductible,
                    life_insurance: this.life_insurance,
                    life_insurance_active: this.life_insurance_active,
                    insurance_amount: this.life_insurance === 'Ja' ? this.insurance_amount : '',
                    insurance_start_date: this.insurance_start_date,
                    owns_horse: this.owns_horse,
                };

                for (let field of extraPriceFields) {
                    data[field] = this[field];
                }

                axios.post('/step/' + slug + '/price', data).then(response => {
                    this.price = response.data.price;
                    this.errors = {};
                }).catch(error => {
                    this.price = 0;

                    if (error.response && error.response.data && error.response.data.errors) {
                        this.errors = error.response.data.errors;
                    }

                    if (error.response && error.response.status === 419) {
                        window.location.reload();
                    }
                });
            }, 250);
        },

        setupWatchers() {
            this.$watch(() => [
                this.veterinary_care,
                this.veterinary_care_deductible,
                this.insurance_start_date,
                this.owns_horse,
                ...extraWatchFields.map(f => this[f]),
            ], () => {
                this.updateDeductiblePretty();
                this.updatePrice();
            });

            this.$watch(() => this.life_insurance_active, () => {
                this.life_insurance = this.life_insurance_active ? 'Ja' : 'Nej';
            });

            this.$watch(() => this.life_insurance, () => {
                this.life_insurance_active = this.life_insurance === 'Ja';
                this.getMeta();
                this.updatePrice();
            });

            let insuranceAmountTimeout = null;
            this.$watch(() => this.insurance_amount, () => {
                clearTimeout(insuranceAmountTimeout);
                insuranceAmountTimeout = setTimeout(() => {
                    this.updatePrice();
                }, 500);
            });
        },

        saveCustomization() {
            this.loading = true;

            let data = {
                veterinary_care: this.veterinary_care,
                veterinary_care_deductible: this.veterinary_care_deductible,
                life_insurance: this.life_insurance,
                life_insurance_active: this.life_insurance_active,
                insurance_amount: this.insurance_amount,
                insurance_start_date: this.insurance_start_date,
                owns_horse: this.owns_horse,
                price: this.price,
            };

            for (let field of extraPriceFields) {
                data[field] = this[field];
            }

            axios.post('/step/' + slug + '/save', data).then(response => {
                this.loading = false;
                window.location.href = '/#' + response.data.next_step;
            }).catch(error => {
                this.loading = false;
                this.errors = error.response.data ? error.response.data.errors : {};

                if (error.response.status === 419) {
                    window.location.reload();
                }

                if (Object.keys(this.errors).length > 0) {
                    window.scrollto.selector('[name=' + Object.keys(this.errors)[0] + ']', 120);
                }
            });
        },

        handleInsuranceAmountKeyup() {
            delete this.errors.insurance_amount;

            if (this.insurance_amount) {
                this.insurance_amount = currencyFormat(this.insurance_amount);
            } else {
                this.insurance_amount = '';
            }
        },
    }
}
